import { useEffect, RefObject } from 'react';
import useCommonStore from 'store/useCommonStore';

/** 테이블 리사이징이 가능하도록 하는 hook */
const useTableResizing = (
	column_ref: RefObject<HTMLDivElement[] | null[]>,
	resizer_ref: RefObject<HTMLDivElement[] | null[]>,
) => {
	const { setIndexColumnWidth, column_width, header } = useCommonStore();

	useEffect(() => {
		if (column_ref.current?.length === 0) return;
		if (resizer_ref.current?.length === 0) return;

		const resizingEvent = (type: 'add' | 'remove') => {
			return column_ref.current?.map((cell, idx) => {
				if (resizer_ref.current?.[idx] === undefined) return;
				let x = 0; // 마우스 클릭 시 위치 값
				let w = 0; // 현재 컬럼 헤더의 넓이 (style)

				const mouseDownHandler = function (e: MouseEvent) {
					if (column_ref.current === null || !cell) return;
					x = e.clientX;

					const styles = window.getComputedStyle(cell);
					w = parseInt(styles.width, 10);

					document.addEventListener('mousemove', mouseMoveHandler);
					document.addEventListener('mouseup', mouseUpHandler);
				};

				const mouseMoveHandler = function (e: MouseEvent) {
					if (column_ref.current === null) return;
					// 클릭 위치로부터 지금까지 이동한 거리
					const dx = e.clientX - x;

					// 리사이저가 앞 칼럼에도 존재하는 지의 여부를 체크
					const resizer_w = idx !== 0 && header[idx - 1].type === 'none' ? 8 : 16;

					// 변경할 넓이 값 : 기존 넓이 + 이동한 거리 + 리사이저의 넓이
					const changed_width = w + dx + resizer_w;

					// 해당 인덱스의 전역 상태 업데이트
					if (changed_width < 64 || !cell) return;
					setIndexColumnWidth(idx, changed_width);
				};

				const mouseUpHandler = function () {
					document.removeEventListener('mousemove', mouseMoveHandler);
					document.removeEventListener('mouseup', mouseUpHandler);
				};

				if (resizer_ref?.current && type === 'add') {
					resizer_ref?.current[idx]?.addEventListener('mousedown', mouseDownHandler);
				} else if (resizer_ref?.current && type === 'remove') {
					resizer_ref?.current[idx]?.removeEventListener('mousedown', mouseDownHandler);
				}
			});
		};

		resizingEvent('add');

		return () => {
			resizingEvent('remove');
		};
	}, [column_ref, resizer_ref, header]);
};

export default useTableResizing;
